import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import HomePage from "@/pages/HomePage";
import DirectoryPage from "@/pages/DirectoryPage";
import CafeDetailPage from "@/pages/CafeDetailPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import SubmitCafePage from "@/pages/SubmitCafePage";
import ProfilePage from "@/pages/ProfilePage";
import CityPage from "@/pages/CityPage";
import CitiesIndexPage from "@/pages/CitiesIndexPage";
import AdminNewslettersPage from "@/pages/AdminNewslettersPage";
import AdminQueuePage from "@/pages/AdminQueuePage";
import AdminReportsPage from "@/pages/AdminReportsPage";
import AdminClaimsPage from "@/pages/AdminClaimsPage";
import AdminListsPage from "@/pages/AdminListsPage";
import ListsIndexPage from "@/pages/ListsIndexPage";
import ListDetailPage from "@/pages/ListDetailPage";

function App() {
  return (
    <div className="App min-h-screen bg-background flex flex-col">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/directory" element={<DirectoryPage />} />
              <Route path="/cafe/:id" element={<CafeDetailPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/submit" element={<SubmitCafePage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/city/:slug" element={<CityPage />} />
              <Route path="/cities" element={<CitiesIndexPage />} />
              <Route path="/admin/newsletters" element={<AdminNewslettersPage />} />
              <Route path="/admin/cafes" element={<AdminQueuePage />} />
              <Route path="/admin/reports" element={<AdminReportsPage />} />
              <Route path="/admin/claims" element={<AdminClaimsPage />} />
              <Route path="/admin/lists" element={<AdminListsPage />} />
              <Route path="/lists" element={<ListsIndexPage />} />
              <Route path="/list/:slug" element={<ListDetailPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#F9F6F0",
                color: "#2C1E16",
                border: "1px solid #E2D9CC",
                borderRadius: "2px",
                fontFamily: "Manrope, system-ui, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
